import React from "react";
import { ReactComponent as IconOne } from "../../assets/icons/NewIcons/IconOne.svg";
import { ReactComponent as ResultIcon } from "../../assets/icons/NewIcons/ResultIcon.svg";
import { ReactComponent as WinRateIcon } from "../../assets/icons/NewIcons/winRateIcon.svg";
import { ReactComponent as AverageProfitIcon } from "../../assets/icons/NewIcons/averageProfitIcon.svg";
import { ReactComponent as RRRIcon } from "../../assets/icons/NewIcons/rrrIcon.svg";
import { dollarUS } from "../../utilities/formatters";

const Card = ({ data, icon, dataTwo }) => {
  return (
    <>
      <div className="card">
        <div className="card-header">
          <span className="card-title">{"No. of Trades"}</span>
          <span className="card-icon">
            <IconOne />
          </span>
        </div>
        <div className="card-content">
          <div className="card-section">
            <span className="card-label card-long-label">{"Long"}</span>
            <div className="card-value card-long-value">
              {Number(data?.number_of_long_trade).toFixed(0) || "--"}
            </div>
          </div>
          <div className="card-section">
            <span className="card-label card-short-label">{"Short"}</span>
            <div className="card-value card-short-value">
              {Number(data?.number_of_Short_trade).toFixed(0) || "--"}
            </div>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card-header">
          <span className="card-title">{"Results"}</span>
          <span className="card-icon">
            <ResultIcon />
          </span>
        </div>
        <div className="card-content">
          <div className="card-section">
            <span className="card-label card-long-label">{"Long"}</span>
            <div className="card-value card-long-value">
              {/* {Number(dataTwo?.long_result) > 0
                ? Number(dataTwo?.long_result).toFixed(2)
                : 0 || "--"} */}
              {Number(dataTwo?.long_result).toFixed(2)}
            </div>
          </div>
          <div className="card-section">
            <span className="card-label card-short-label">{"Short"}</span>
            <div className="card-value card-short-value">
              {/* {Number(dataTwo?.short_result) < 0
                ? Number(dataTwo?.short_result).toFixed(2)
                : 0 || "--"} */}
              {Number(dataTwo?.short_result).toFixed(2)}
            </div>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card-header">
          <span className="card-title">{"Win Rate"}</span>
          <span className="card-icon">
            <WinRateIcon />
          </span>
        </div>
        <div className="card-content">
          <div className="card-section">
            <span className="card-label card-long-label">{"Long"}</span>
            <div className="card-value card-long-value">
              {data?.long_win_rate
                ? `${Number(data.long_win_rate).toFixed(2)}%`
                : "--"}
            </div>
          </div>
          <div className="card-section">
            <span className="card-label card-short-label">{"Short"}</span>
            <div className="card-value card-short-value">
              {data?.short_win_rate
                ? `${Number(data.short_win_rate).toFixed(2)}%`
                : "--"}
            </div>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card-header">
          <span className="card-title">{"Average Profit"}</span>
          <span className="card-icon">
            <AverageProfitIcon />
          </span>
        </div>
        <div className="card-content">
          <div className="card-section">
            <span className="card-label card-long-label">{"Long"}</span>
            <div className="card-value card-long-value">
              {dollarUS(Number(data?.long_avg_profit).toFixed(2)) || "--"}
            </div>
          </div>
          <div className="card-section">
            <span className="card-label card-short-label">{"Short"}</span>
            <div className="card-value card-short-value">
              {dollarUS(Number(data?.short_avg_profit).toFixed(2)) || "--"}
            </div>
          </div>
        </div>
      </div>
      <div className="card">
        <div className="card-header">
          <span className="card-title">{"RRR"}</span>
          <span className="card-icon">
            <RRRIcon />
          </span>
        </div>
        <div className="card-content">
          <div className="card-section">
            <span className="card-label card-long-label">{"Long"}</span>
            <div className="card-value card-long-value">
              {data?.long_rrr?.toFixed(2) || "--"}
            </div>
          </div>
          <div className="card-section">
            <span className="card-label card-short-label">{"Short"}</span>
            <div className="card-value card-short-value">
              {data?.short_rrr?.toFixed(2) || "--"}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const LongShortCards = ({ data, dataTwo }) => {
  // const cardData = [
  //   {
  //     title: "No. of trades",
  //     icon: <Icon1 />,
  //     long: data && data.number_of_long_trade,
  //     short: data && data.number_of_Short_trade,
  //   },
  //   {
  //     title: "Results",
  //     icon: <Icon2 />,
  //     long: data && data.long_profit,
  //     short: data && data.short_profit,
  //   },
  //   {
  //     title: "Win Rate",
  //     icon: <Icon3 />,
  //     long: data && data.long_win_rate && `${data.long_win_rate}%`,
  //     short: data && data.short_win_rate && `${data.short_win_rate}%`,
  //   },
  //   {
  //     title: "Average Profit",
  //     icon: <Icon4 />,
  //     long: data && data.long_avg_profit,
  //     short: data && data.short_avg_profit,
  //   },
  //   {
  //     title: "RRR",
  //     icon: <Icon5 />,
  //     long: data && data.long_rrr,
  //     short: data && data.short_rrr,
  //   },
  // ];

  return (
    <div className="cards-container">
      <Card data={data} dataTwo={dataTwo} />
    </div>
  );
};

export default LongShortCards;
